import React, { useRef, useState } from "react";
import { ImageCanvasPreview } from "../../features/annotation";

/* ---------------- Main ---------------- */

type EachPagePdfProps = {
  view: any;
  fileName: string;
  images?: any[];
  damages: any;
  user: any;
  inspectionId: any;
  idx: number
};

const EachPagePdf = ({
  view,
  images = [],
  inspectionId,
  idx,
}: EachPagePdfProps) => {
  const hiddenPdfImgRef = useRef<HTMLImageElement | null>(null);

  const [imageFrame, setImageFrame] = useState({
    width: 0,
    height: 0,
  });

  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { width, height } = e.currentTarget;
    setImageFrame({ width, height });
  };
  return (
    <div
      className={`i${inspectionId}-pdf-page w-full m-0 p-0 font-sans text-[14px] text-[#404040] leading-[21px] bg-[#f6f6f6]`}
    >
      <div className="h-full relative bg-[#f6f6f6] border-l-[20px] border-[#e94f2c]">
        
        <div className="bg-white min-h-screen">
          {images.map((item, index) => {
            const code =
						  item.aiag?.damageArea?.code +
						  item.aiag?.damageType?.code +
              item.aiag?.damageSeverity?.code;
						const label =
						  item.aiag?.damageArea?.description + ' ' + 
						  item.aiag?.damageType?.description + ' ' + 
              item.aiag?.damageSeverity?.description;

						

            return (
              <div key={index} className="p-[10px]">
                <div className="flex justify-center relative" 
									style={{
									borderTop: "1px solid #dadada",
									padding: "160px 80px",
									background: "#FFFFFF",
									display: "flex",
									justifyContent: "space-between",
								}}
								>
                  
                  {/* LEFT ROTATED INFO */}
                  {/* <div className="w-1/6 rotate-[-90deg] origin-top text-nowrap mt-[500px]"> */}
                  <div className="absolute left-20 bottom-10 rotate-[-90deg] origin-left">
                    {imageFrame.width > 0 && (
                      <>
                        <div
                          className="flex items-end justify-between border-b border-gray-300 pb-[5px] ml-[100px]"
                          style={{ width: imageFrame.height - 100 }}
                        >
                          <h4 className="m-0 font-normal">
                            {code || "00000"} |{" "}
                            {item?.source === "AI" ? "AI" : "Manual"}
                          </h4>
                        </div>

                        <h4
                          className="text-gray-500 m-0 pt-[7px] font-normal ml-[100px] break-words whitespace-normal"
                          style={{ width: imageFrame.height - 100 }}
                        >
                          {label}
                        </h4>
                      </>
                    )}
                  </div>

                  {/* RIGHT IMAGE */}
                  <div className="w-4/5 flex justify-right pl-[60px]">
                    {imageFrame.width === 0 ? (
                      <img
                        ref={hiddenPdfImgRef}
                        src={item.base64}
                        onLoad={handleImageLoad}
                        alt="hidden"
												style={{
													position: "absolute",
													visibility: "hidden",
													height: "auto",
													width: "80%",
												}}
                      />
                    ) : (
                      <ImageCanvasPreview
                        imageUrl={item.base64}
                        data={item}
                        damages={[item]}
                        dimensions={imageFrame}
                        onModalToggle={() => {}}
                        pageInfo={12}
                        user={{}}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EachPagePdf;
